class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.shouldOpen = true;
    this.elements.button.addEventListener('mousedown', this.onButtonMouseDown.bind(this));
    this.elements.button.addEventListener('mouseup', this.onButtonMouseUp.bind(this));
    this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', this.onItemClick.bind(this));
      item.addEventListener('focusout', this.onItemFocusout.bind(this));
    });
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', 'true');
    this.elements.button.focus();
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
  }

  onItemFocusout(event){
    var self = this
    setTimeout(function(){
      var newFocus = document.activeElement;
      if(!newFocus.closest('#CountryList')){
        self.hidePanel();
      }
    },100);
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const newLocation = event.currentTarget.dataset.value;
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form){
      // if the new location isn't US or Canada, clear cart
      if(newLocation !== "CA" && newLocation !== "US") {
        clearCart(function() {
          localStorage.setItem('popupHide', true);
          localStorage.setItem('popupLocation', "United Kingdom");
          form.submit();
        });
        return;
      }
      // update the cart with correct information
      generateNewLocationCart(newLocation, function() {
        localStorage.setItem('popupHide', true);
        localStorage.setItem('popupLocation', newLocation == "US" ? "United States" : "Canada");
        form.submit();
      });
    }
  }

  onButtonMouseDown() {
    this.shouldOpen = this.elements.panel.getAttribute('hidden') !== null;
  }

  onButtonMouseUp() {
    if (this.shouldOpen) {
      this.openSelector();
    } else {
      this.hidePanel();
    }
    this.shouldOpen = false;
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', 'true');
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
